import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Link } from "gatsby"
import ArrowLeftStroke from "@zendeskgarden/svg-icons/src/16/arrow-left-stroke.svg"

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.document.links};

  &:hover,
  &:active,
  &:focus {
    color: ${props => props.theme.colors.document.links};
    text-decoration: underline;
  }
`

const StyledArrow = styled(ArrowLeftStroke)`
  margin-left: ${props => props.theme.space.xs};
  transform: rotate(180deg);
`

const ArrowLink = ({ className, children, href, isFocusable }) => (
  <StyledLink className={className} to={href} tabIndex={isFocusable ? 0 : -1}>
    {children}
    <StyledArrow />
  </StyledLink>
)

ArrowLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  href: PropTypes.string.isRequired,
  isFocusable: PropTypes.bool
}

ArrowLink.defaultProps = {
  className: null,
  isFocusable: true
}

export default ArrowLink
